import { makeStyles } from "@saleor/macaw-ui";

const useStyles = makeStyles(
  theme => ({
    root: {
      width: "100%",
      borderWidth: 2,
      borderStyle: "solid",
      borderColor: theme.palette.info.dark,
      backgroundColor: theme.palette.background.paper,
      margin: 0,
      "& .MuiFormControl-root": {
        width: "100%"
      }
    },
    detail: {
      height: "fit-content"
    },
    upload: {
      height: "fit-content"
    },
    rowText: {
      paddingTop: 6,
      display: "flex",
      flexWrap: "wrap"
    },
    readOnlyNumber: {
      minHeight: 32,
      textAlign: "end",
      padding: "0.6rem 1.6rem",
      wordBreak: "break-word"
    },
    readOnlyText: {
      minHeight: 32,
      padding: "0.6rem 1.6rem",
      wordBreak: "break-word"
    },
    textBold: {
      fontWeight: "bold"
    },
    numberInput: {
      width: "100%"
    },
    checkbox: {
      margin: "0 8px 3px 0",
      height: 15,
      width: 15
    },
    selectField: {
      height: 32,
      "& .MuiSelect-root": {
        padding: "0.8rem 1.2rem",
        color: theme.palette.grey[800]
      }
    },
    countTextField: {
      marginBottom: 0,
      "& .fieldZone": {
        padding: 0,
        minHeight: 32,
        overflow: "hidden",
        "& textarea": {
          display: "block",
          padding: "0.4rem 1.2rem"
        }
      }
    },
    textResult: {
      marginTop: 5,
      fontSize: 12
    },
    textError: {
      color: theme.palette.error.light
    },
    textSuccess: {
      color: theme.palette.success.main
    },
    textPending: {
      color: theme.palette.warning.main
    },
    tooltipPopper: {
      "& .MuiTooltip-tooltip": {
        maxWidth: 400
      }
    },
    infoIcon: {
      color: theme.palette.info.main,
      marginTop: 3,
      fontSize: 16
    }
  }),
  { name: "CashSaleForm" }
);

export default useStyles;
